import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { FormElement } from "app/types";
import { IAvatar, IFormError, IMySettingForm } from "../types";
import { set } from "lodash";

export const useClinicSlice = createSlice({
  name: "mySettingState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    // Form
    setMySettingFormValues: (state, action) => {
      const { name, value } = action.payload;
      const field = state.form[name];

      if (typeof field === "object" && field !== null && "value" in field) {
        (field as FormElement).value = value as string;
        (field as FormElement).error = "";
      } else {
        state.form[name] = value as typeof field;
      }
    },
    setMySettingFormErrors: (state, action: PayloadAction<IFormError[]>) => {
      action.payload.forEach(({ name, error }) => {
        set(state.form, `${name}.error`, error);
      });
    },
    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `form.${action.payload.key}`, action.payload.value);
    },

    clearMySettingForm: (state) => {
      state.form = initialState.form;
    },

    getUserDetails: (state) => {
      state.isLoading = true;
    },
    setUserDetails: (state, action: PayloadAction<IMySettingForm>) => {
      const user = action.payload;
      state.form = { ...state.form, ...user };
    },
    updateFullName: (state) => {},
    updatePreferences: (state) => {},
    updateCountry: (state) => {},
    updateLanguage: (state) => {},
    updateEmail: (
      state,
      action: PayloadAction<{ newEmail: string; callback: () => void }>
    ) => {
      state.changeEmailRequestId = "";
      state.verifyCodeError = "";
    },
    verifyChangeEmail: (
      state,
      action: PayloadAction<{ code: string; id: string; callback?: () => void }>
    ) => {
      state.verifyCodeError = "";
    },
    updatePassword: (
      state,
      action: PayloadAction<{ callback: () => void }>
    ) => {},
    setIsButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },
    clearPasswordFormValue: (state) => {
      state.form.oldPassword.value = "";
      state.form.newPassword.value = "";
      state.form.confirmPassword.value = "";
    },
    updateProfile: (
      state,
      action: PayloadAction<{ avatar: IAvatar,callback: () => void }>
    ) => {},
    updateAvatarFormValue: (state, action: PayloadAction<IAvatar>) => {
      state.form.avatar = action.payload;
    },
     updateMobileNumber: (
      state,
      action: PayloadAction<{ mobileNumber: string; callback: () => void }>
    ) => {},
    updateMobileNumberSuccess: (state, action: PayloadAction<string>) => {
      state.form.mobileNumber = action.payload;
    },
    setVerifyCodeError: (state, action: PayloadAction<string>) => {
      state.verifyCodeError = action.payload;
    },
    clearVerifyCodeError: (state) => {
      state.verifyCodeError = "";
    },
    setChangeEmailRequestId: (state, action: PayloadAction<string>) => {
      state.changeEmailRequestId = action.payload;
    },
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
